import { useEffect, useState } from "react";

/** Compact overlay navigation. Desktop at 1101px+ uses the persistent rail. */
export const COMPACT_NAVIGATION_QUERY = "(max-width: 1100px)";

export const SIDEBAR_EXPANDED_STORAGE_KEY = "backchannel.tax.sidebar-expanded";

export function readSidebarExpanded(): boolean {
  if (typeof window === "undefined") return true;
  try {
    const value = window.localStorage.getItem(SIDEBAR_EXPANDED_STORAGE_KEY);
    if (value === "false") return false;
    if (value === "true") return true;
  } catch {
    // Private mode can block storage.
  }
  return true;
}

export function writeSidebarExpanded(expanded: boolean) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(SIDEBAR_EXPANDED_STORAGE_KEY, String(expanded));
  } catch {
    // Ignore quota / privacy failures; the session still toggles in memory.
  }
}

export function useCompactNavigation(): boolean {
  const [compact, setCompact] = useState(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return false;
    }
    return window.matchMedia(COMPACT_NAVIGATION_QUERY).matches;
  });

  useEffect(() => {
    const media = window.matchMedia(COMPACT_NAVIGATION_QUERY);
    const sync = () => setCompact(media.matches);
    sync();
    media.addEventListener("change", sync);
    return () => media.removeEventListener("change", sync);
  }, []);

  return compact;
}
